import React, { useState } from 'react';
import './MainApp.css';
import { useEffect } from 'react';
import Map from './components/Map/Base/Map';
import logo from './assets/avispat_vespa_fons_blanc.png'; // Importa el logo
import userIcon from './assets/user-icon.png'; // Importa el icono de usuario
import RiskPage from './components/Risk/RiskPage';
import MeteoDashboard from './components/Meteo/MeteoDashboard';
import SoilSensorsDashboard from './components/SoilSensorsDashboard/SoilSensorDashboard';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import GatewayCameraGrid from './components/Camera/GatewayCameraGrid';
import SimulationPage from './components/Simulation/SimulationPage';
import SynopticPage from './components/Synoptic/SynopticPage';
import DronesPage from './components/Drones/DronesPage';
import AlerpatPage from './components/Alerpat/AlerpatPage';
import CecopalLink from './components/Utils/CecopalLink';
import Link112 from './components/Utils/Link112';
import ChangePasswordModal from './components/ChangePasswordModal';
import versionData from './version.json';


const MainApp = ({ onLogout, can }) => {
  const [view, setView] = useState('map'); // Estado para manejar la vista activa
  const [menuOpen, setMenuOpen] = useState(false); // Estado para manejar el menú desplegable
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const [synopticId, setSynopticId] = useState('general');

  const isMobile = window.innerWidth <= 768;

  const handleViewChange = (newView) => {
    window.history.pushState({ view: newView }, '');
    setView(newView);
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    navigator.serviceWorker?.addEventListener("message", (event) => {
      if (event.data?.type === "OPEN_VIEW") {
        const targetView = event.data.targetView;
        window.history.pushState({ view: targetView }, '');
        setView(targetView);
        setSidebarOpen(false);
      }
    });

    // Si la app se abrió con ?view=risk
    const params = new URLSearchParams(window.location.search);
    const viewParam = params.get("view");
    const initialView = viewParam || 'map';
    if (viewParam) {
      setView(viewParam);
    }
    window.history.replaceState({ view: initialView }, '');

    const handlePopState = (event) => {
      if (event.state?.view) {
        setView(event.state.view);
        setSidebarOpen(false);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    if ('clearAppBadge' in navigator) {
      navigator.clearAppBadge();
    }
  }, []);





  // Renderizado condicional del contenido central
  const renderContent = () => {
    if (view === 'map') {
      return <Map can={can} />;
    } else if( view === 'detectors') {
      return <AdminDashboard isAdmin={can(['admin'])} />;
    } else if( view === 'meteos') {
      return <MeteoDashboard meteoId="torrevallesa" can={can} />
    }
     else if (view === 'cannons') {
      return <h2>Estado de los cañones</h2>;
    } else if (view === 'risk') {
      return <RiskPage isAdmin={can(['admin'])} canManageCannons={can(['admin', 'cannon-manager'])} />;
    } else if (view === 'cameras') {
      return <GatewayCameraGrid gatewayUrl="https://camgateway.senticnel.com" />;
    } else if( view === 'soil-sensors') {
      return <SoilSensorsDashboard soilSensorId="nando14" />
    }
     else if (view === 'simulation') {
      return <SimulationPage isAdmin={can(['admin'])} />;
    } else if (view === 'synoptic') {
      return <SynopticPage synopticId={synopticId} setSynopticId={setSynopticId} />;
    } else if (view === 'drones') {
      return <DronesPage can={can} />;
    } else if (view === 'alerpat') {
      return <AlerpatPage can={can} />;
    }
  };

  return (
    <div className="app">
      <header className="header">
        <button
          className={`hamburger ${sidebarOpen ? 'open' : ''}`}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? '✖' : '☰'}
        </button>


        <img src={logo} alt="Logo" className="logo" />
        <div className="user-menu">
          <span className="user-name">{localStorage.getItem('fullname') || ''}</span>
          <img
            src={userIcon}
            alt="User Icon"
            className="user-icon"
            onClick={() => setMenuOpen(!menuOpen)}
          />
          
          {menuOpen && (
            <div className="dropdown-menu">
              {can(['admin']) && <p style={{ textAlign: 'center' }}>*Administrador*</p>}
              <p style={{ textAlign: 'center' , fontWeight: 'bold' }}>{localStorage.getItem('fullname') || ''}</p>
              <button onClick={() => { setShowPasswordModal(true); setMenuOpen(false); }}>🔑 Cambiar contraseña</button>
              <button onClick={onLogout}>➡️ Cerrar sesión</button>
            </div>
          )}
        </div>
      </header>

      {showPasswordModal && (
        <ChangePasswordModal onClose={() => setShowPasswordModal(false)} />
      )}

      {/* Contenido de la app */}
      <div className="main-layout">
        <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
          <button onClick={() => handleViewChange('map')}>Mapa</button>
          
          
          { can(['soil-sensor-viewer','admin']) && (
            <button onClick={() => handleViewChange('soil-sensors')}>Sensores suelo</button>
          )}

          { can(['camera-viewer','admin']) && (
            <button onClick={() => handleViewChange('cameras')}>Cámaras</button>
          )}
          { can(['drone-viewer','drone-manager','admin']) && (
            <button onClick={() => handleViewChange('drones')}>Drones</button>
          ) }
          { can(['cannon-manager','admin']) && (
            <button onClick={() => handleViewChange('synoptic')}>Sinóptico</button>
          ) }

          {can(['risk-viewer','admin']) && (
            <button onClick={() => handleViewChange('risk')}>Riesgo</button>
          )}
          {can(['alerpat-user', 'admin']) && (
            <button onClick={() => handleViewChange('alerpat')}>AlerPAT</button>
          )}
          {can(['meteo-viewer','admin']) && (
            <button onClick={() => handleViewChange('meteos')}>Meteos</button>
          )}
          {can(['simulation-viewer','admin']) && (
            <button onClick={() => handleViewChange('simulation')}>Simulaciones</button>
          )}

          {can(['admin']) && (
            <button
              onClick={() => handleViewChange('detectors')}
              className="sidebar-live-button"
            >
              Live
            </button>
          )}

          <Link112 fileUrl = 'avisos' linkName = 'Avisos riesgos 112' />
          <Link112 fileUrl = 'previfoc' linkName = 'Previfoc' showLevel />
          { localStorage.getItem('username') === 'cecopal' && <CecopalLink /> }

          <span style={{ padding: '8px', fontSize: '11px', color: '#555', textAlign: 'center' }}>
            v{versionData.version}
          </span>
        </aside>
        <main className="content">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default MainApp;
